import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  // eslint-disable-next-line react-native/no-color-literals
  container: {
    borderRadius: 8,
    shadowRadius: Platform.select({
      web: 6,
      default: 3,
    }),
    shadowColor: 'black',
    shadowOpacity: 0.2,
    shadowOffset: { width: 0, height: 0 },
    elevation: 4,
    borderWidth: 1,
  },
  solid: {
    shadowRadius: 0,
    elevation: 0,
    shadowOpacity: 0,
    borderWidth: 1,
  },
});
